import styled from 'styled-components';

export const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImageWrapper = styled.div`
  margin-bottom: var(--cc_size_spacing_xl);
  text-align: center;
`;

export const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_xl);
  align-items: flex-start;
  margin-left: var(--cc_size_spacing_l);
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FeatureList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_s);
  list-style: none;
  margin: 0 0 var(--cc_size_spacing_l);
`;

export const FeatureListItem = styled.li`
  display: flex;
  gap: var(--cc_size_spacing_s);
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_text_primary);
  margin-bottom: var(--cc_size_spacing_xs);
`;

export const FooterContentStyle = styled.div`
  margin: 0 40px;
`;
